import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CallToAction: React.FC = () => (
  <section className="section relative z-10 w-full py-14 md:py-20 flex flex-col items-center text-center">
    <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight mb-4">
      Your Smarter Financial Future Starts Today
    </h2>
    <p className="text-lg md:text-xl text-white/90 mb-8 max-w-xl mx-auto">
      Take control of your money, uncover hidden savings, and reach your goals
      faster — all in one simple, secure app. It’s free to start, and you’ll see
      the difference from day one.
    </p>
    <div className="flex gap-5 justify-center flex-wrap">
      <Link
        to="/get-started"
        className="btn-primary text-base px-7 py-3 rounded-3xl"
      >
        Start Tracking Today <ArrowRight className="ml-2 w-5 h-5" />
      </Link>
      <Link
        to="/features"
        className="btn-secondary text-base px-7 py-3 rounded-3xl"
      >
        Explore Features
      </Link>
    </div>
    <span className="block mt-8 text-sm text-white/70">
      Free forever on Basic. No card needed.
    </span>
  </section>
);

export default CallToAction;
